import { type SxProps, type Theme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';

// utils to fix `sx` typing error when it returns an array
// @see https://github.com/mui/material-ui/issues/37730
export const isSxArray = (
  sx: SxProps<Theme>,
): sx is ReadonlyArray<
  boolean | SystemStyleObject<Theme> | ((theme: Theme) => SystemStyleObject<Theme>)
> => {
  return Array.isArray(sx);
};
